const placedPCellMap = new Map();

function clone(value) {
  return JSON.parse(JSON.stringify(value));
}

export function registerPlacedPCell(entry) {
  if (!entry?.cellName) {
    throw new Error("cellName is required to register placed PCell");
  }

  const normalized = {
    cellName: entry.cellName,
    patternType: entry.patternType || "",
    patternKey: entry.patternKey || "",
    parentCellName: entry.parentCellName || "",
    placementType: entry.placementType || "pcell",
    parameters: Array.isArray(entry.parameters) ? clone(entry.parameters) : [],
    definitionSnapshot: entry.definitionSnapshot ? clone(entry.definitionSnapshot) : null,
    dots: entry.dots ? clone(entry.dots) : { gridSize: null, visible: true },
    connections: Array.isArray(entry.connections) ? clone(entry.connections) : [],
    isDraftPreview: Boolean(entry.isDraftPreview),
  };

  placedPCellMap.set(normalized.cellName, normalized);

  window.dispatchEvent(
    new CustomEvent("placed-pcell-registered", {
      detail: clone(normalized),
    })
  );

  return clone(normalized);
}

export function getPlacedPCell(cellName) {
  const item = placedPCellMap.get(cellName);
  return item ? clone(item) : null;
}

export function getAllPlacedPCells() {
  return Array.from(placedPCellMap.values()).map(clone);
}

export function hasPlacedPCell(cellName) {
  return placedPCellMap.has(cellName);
}

export function updatePlacedPCell(cellName, updates = {}) {
  const current = placedPCellMap.get(cellName);
  if (!current) return null;

  const next = {
    ...current,
    ...clone(updates),
  };

  placedPCellMap.set(cellName, next);

  window.dispatchEvent(
    new CustomEvent("placed-pcell-updated", {
      detail: clone(next),
    })
  );

  return clone(next);
}

export function updatePlacedPCellParameters(cellName, parameters = []) {
  return updatePlacedPCell(cellName, {
    parameters: clone(parameters),
  });
}

export function removePlacedPCell(cellName) {
  const existing = placedPCellMap.get(cellName);
  if (!existing) return false;

  placedPCellMap.delete(cellName);

  window.dispatchEvent(
    new CustomEvent("placed-pcell-removed", {
      detail: { cellName },
    })
  );

  return true;
}

export function clearPlacedPCells() {
  placedPCellMap.clear();
}